/**
 * Debug-guarded logger.
 * In production only errors and warnings reach the console.
 */

const IS_DEV = process.env.NODE_ENV !== 'production';
const noop = () => {};

export const logger = {
  log:   IS_DEV ? console.log.bind(console)   : noop,
  info:  IS_DEV ? console.info.bind(console)  : noop,
  warn:  console.warn.bind(console),
  error: console.error.bind(console),
  debug: IS_DEV ? console.debug.bind(console) : noop,
};
